export const outerCardPt = {
  root: { class: "border-t-8 border-t-teal-500 bg-white rounded-lg" },
  header: { class: "p-0 border-b border-gray-200" },
  body: { class: "p-0" },
  content: { class: "p-0" },
};

export const collapseButtonPt = {
  root: {
    class: "w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-200",
  },
};

export const sessionCardPt = {
  root: { class: "border-t-8 border-t-teal-500 rounded-lg shadow-md shadow-teal-500/25" },
  header: { class: "p-0 bg-gray-50 border-b border-gray-100" },
  body: { class: "p-0" },
  content: { class: "p-3.5" },
};

export const viewDetailButtonPt = {
  root: { class: "text-xs text-blue-600 hover:underline p-0 bg-transparent border-0" },
};

export const previousSessionsCardPt = {
  root: { class: "border border-gray-200 rounded-lg overflow-hidden shadow-md shadow-teal-500/25" },
  body: { class: "p-0" },
  content: { class: "p-0" },
};

export const accordionTabPt = {
  headerAction: { class: "px-4 py-3 bg-white border-0 rounded-none text-gray-700 hover:bg-gray-50" },
  headerIcon: { class: "text-gray-500 text-sm mr-2" },
  content: { class: "!pt-0 !pl-0 !pr-0" },
};

export const warningTagPt = {
  root: { class: "bg-transparent text-amber-600 border-0 text-xs p-0 italic font-normal" },
};

export const viewLinkButtonPt = {
  root: { class: "text-blue-600 text-xs p-0" },
};

export const dividerPt = {
  root: { class: "m-0 p-0" },
};

export const paginatorPt = {
  root: { class: "flex items-center justify-center gap-1 px-4 py-3 border-t border-gray-200 bg-white" },
  firstPageButton: { class: "w-7 h-7 text-gray-500 rounded hover:bg-gray-100" },
  prevPageButton: { class: "w-7 h-7 text-gray-500 rounded hover:bg-gray-100" },
  nextPageButton: { class: "w-7 h-7 text-gray-500 rounded hover:bg-gray-100" },
  lastPageButton: { class: "w-7 h-7 text-gray-500 rounded hover:bg-gray-100" },
  pageButton: ({ context }) => ({
    class: ["w-7 h-7 text-xs rounded hover:bg-gray-100", context.active ? "font-bold text-gray-900" : "text-gray-600"],
  }),
  current: { class: "text-xs text-gray-500 mr-2" },
};
